export default {
	"审卷":'Questionnaire audit',
	"修改记录":'Record of modification',
	"修改用户":'User responsible for modification',
	"修改时间":'Modification time',
	"暂无记录":'No record',
	"上一页":'Previous page',
	"下一页":'Next page',
	"修改题目":'Modified question',
	"详细数据":'Detailed data',
	"请先确认上一个产品":'Please confirm the previous product first',
	"请选择地址":'Please select address',
	"问卷视图":'Questionnaire view',
	"产品视图":'Product view',
	"产品员视图":'Product staff view',
	"桌":'table',
	"当前没有问卷进行中":'No questionnaire is currently in progress',
	"停留时间":'Dwell time',
	"第":'Product ',
	"个产品":'',
	"页":'page',
	"共":'A total of',
	"未开始":'Not yet started',
	"已完成":'Completed',
	"已结束":'Ended',
	"进行中":'In progress',
	"甄别问卷":'Screening questionnaire',
	"产品问卷":'Product questionnaire'
}